import * as React from "react";
import {FC, useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {Grid} from "@mui/material";
import {BrickProducts} from "../../BrickMailType";
import {FormInputText} from "../../../../shop/wholesale/form/FormInputText";

export const BrickProductsEditor: FC<{ brick: BrickProducts, onChange: (brick: BrickProducts) => void }> = ({
  brick,
  onChange
}) => {
  const formContext = useFormContext<BrickProducts>();
  const {reset, control} = formContext;

  useEffect(() => {
    reset(brick)
  }, [brick, reset])

  return (
    <div>
      <Grid container spacing={"10px"}>
        <Grid item xs={12}>
          <FormInputText name={"title"} control={control} label={"Title text"}/>
        </Grid>
        <Grid item xs={12}>
          <FormInputText name={"activation"} control={control} label={"Activation expression"}/>
        </Grid>
      </Grid>
    </div>
  );
}